module.exports = __webpack_public_path__ + "img/messege_btn.59dbb59e.svg";